import { USER_ROLE_NAME_MAP } from 'app-config';
import { AxiosError } from 'axios';

// eslint-disable-next-line
export const isResponseError = <T = AxiosError>(error: any): error is T => {
	return error instanceof Error;
};

export const getUserRoleLabel = (role: string) => {
	return USER_ROLE_NAME_MAP[role] || role;
};

export const capitalize = (str: string): string => {
  if (!str) return "";
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};

export const errorMessageHandler = (err: any, defaultMsg = "Something went wrong!!!"): string => {
  const errorMessage =  err?.data?.errors?.[0] || err?.data?.message || err.errors?.[0] || err?.message || defaultMsg;
  return errorMessage;
}

export const normalizeEmail = (email: string): string => email.trim().toLowerCase();

export const getInvalidEmails = (emails: string[]): string[] =>{
  const EMAIL_REGEX = /^(?!\.)(?!.*\.\.)[a-zA-Z0-9._%+-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)+$/;
  return emails.filter(email => !EMAIL_REGEX.test(normalizeEmail(email)));
}
